<template>
  <div
    id="app"
    :style="`background: linear-gradient(to top, ${bg1}, ${bg2});`"
  >
    <div v-if="current" class="char__container">
      <div v-for="char in chars" :key="`char__${char}`" class="char">
        <div class="char__title" @click="changeVariant(char)">
          <transition name="fade">
            <div>
              {{ current[char] }}
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="help">
      <button class="help__refresh" @click="changeWord()">🔁</button>
      <button
        class="help__copy"
        v-clipboard="Object.values(current).join('')"
        v-clipboard:success="clipboardSuccessHandler"
      >
        {{ btnText }}
      </button>
    </div>
  </div>
</template>

<script>
import { charVariantsObject } from "./chars1";

export default {
  name: "App",
  data() {
    return {
      current: undefined,
      bg1: undefined,
      bg2: undefined,
      btnText: '📋'
    };
  },
  mounted() {
    const initArr = this.chars.map((ch) => [ch, this.getRandomVariant(ch)]);
    this.current = Object.fromEntries(initArr);
    this.bg1 = `rgb(${this.randomInteger(0,255)},${this.randomInteger(0,255)},${this.randomInteger(0,255)})`
    this.bg2 = `rgb(${this.randomInteger(0,255)},${this.randomInteger(0,255)},${this.randomInteger(0,255)})`
  },
  computed: {
    charVariantsObj() {
      return charVariantsObject;
    },
    chars() {
      return Object.keys(this.charVariantsObj);
    },
  },
  methods: {
    getVariantsArr(char) {
      return this.charVariantsObj[char];
    },
    chooseRandomVariant(char) {
      return Math.floor(Math.random() * this.getVariantsArr(char).length);
    },
    getRandomVariant(char) {
      return this.charVariantsObj[char][this.chooseRandomVariant(char)];
    },
    changeVariant(char) {
      this.current[char] = this.getRandomVariant(char);
    },
    changeWord() {
      Object.keys(this.current).forEach((ch) => {
        this.changeVariant(ch);
      });
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    clipboardSuccessHandler() {
      this.btnText = '✅'
    },
    clipboardErrorHandler() {
      this.btnText = '❌'
    }
  },
};
</script>

<style>
html,
body {
  min-height: 100%;
}

body {
  margin: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.char__container {
  display: flex;
  align-items: center;
}

.char {
  font-size: 22vw;
  margin: 25px;
}

.char__title {
  cursor: pointer;
  text-transform: uppercase;
  user-select: none;
}

.help {
  position: absolute;
  left: 15px;
  top: 15px;
}

.help__refresh,
.help__copy {
  background: none;
  border: 0;
  box-shadow: 0;
  font-size: 60px;
  cursor: pointer;
  outline: none;
}

.help__refresh:hover,
.help__copy:hover {
  opacity: .5;
}
</style>
